var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-dialog',{attrs:{"visible":_vm.visible,"title":_vm.title,"width":_vm.width,"show-close":_vm.showClose},on:{"update:visible":function($event){_vm.visible=$event}}},[_c('div',{staticClass:"img-container"},[_c('img',{attrs:{"src":_vm.src}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/.13.7.1@vue-loader/lib/template-compiler?{"id":"data-v-71a57ac8","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/.13.7.1@vue-loader/lib/selector.js?type=template&index=0!./src/packages/components/messageBox/components/ImagePreviewBox.vue
// module id = 73
// module chunks = 0 1